import { Close } from "@mui/icons-material";
import { Button, Drawer } from "@mui/material";
import { useMutation } from "@tanstack/react-query";
import InputField from "components/Input/InputField";
import TextArea from "components/Input/TextArea";
import UploadFile from "components/Input/UploadFile";
import axios from "const/axios";
import { useEffect, useState } from "react";
import ReactQuill from "react-quill";
import { toast } from "react-toastify";
import { hasPermission } from "utils/permissionUtils";
import { P } from "const/permissions";

export default function AddCheckList({
  open,
  handleClose,
  refetchCheckList,
  setOpenCheckListDrawer,
  viewOnly = !hasPermission(P.CHECKLIST.READ),
}) {
  const initialState = {
    key1: "",
    key2: "",
    key3: "",
    key4: "",
    key5: "",
    key6: "",
    key7: "",
    key8: "",
    key9: "",
    key10: "",
    arrKey1: [],
    arrKey2: [],
  };

  const [data, setData] = useState(open?.data || initialState);
  useEffect(() => {
    if (open?.id && open?.data) {
      // Merge the existing data with initial state to ensure all fields exist
      setData({ ...open?.data });
    } else {
      setData(initialState);
    }
  }, [open?.id, open?.data]);

  const toggleDrawer = (event) => {
    handleClose();
    setData(initialState);
  };

  const handleInputChange = (e) => {
    setData({ ...data, [e.target.name]: e.target.value });
  };

  const handleAddMore = () => {
    addCheckList({ data, addMore: true });
  };

  const { mutate: addCheckList, isLoading } = useMutation({
    mutationFn: ({ data }) => {
      if (data?.id) {
        return axios.put(`check-list/${open?.id}`, data);
      } else {
        return axios.post(`check-list`, data);
      }
    },
    onSuccess: (response, variables) => {
      toast.success(open?.id ? "Check List updated successfully" : "Check List added successfully");
      if (variables?.addMore) {
        setData(initialState);
      } else {
        handleClose();
      }
      refetchCheckList();
    },
    onError: (err) => {
      toast.error(err?.response?.data?.message || "Error saving price list");
    },
  });

  const handleSave = (type) => {
    addCheckList({ data, addMore: false });
  };

  return (
    <Drawer
      anchor={"right"}
      open={open?.state}
      onClose={handleClose}
      PaperProps={{ style: { width: "35%" } }}
    >
      <div className="flex justify-between p-4 border-b">
        <h1 className="text-xl font-semibold">{open?.id ? "Edit Check List" : "Add Check List"}</h1>
        <Close onClick={toggleDrawer} className="cursor-pointer" />
      </div>
      <div className="p-4 flex flex-col gap-4 overflow-y-auto mb-20">
        <div className="relative w-full mb-3">
          <InputField
            label="Title"
            name="key1"
            value={data?.key1}
            required
            onChange={handleInputChange}
            disabled={viewOnly}
          />
        </div>
        <div className="relative w-full mb-3">
          <InputField
            label="Description"
            name="key2"
            value={data?.key2}
            required
            onChange={handleInputChange}
            disabled={viewOnly}
          />
        </div>
        <div className="relative w-full mb-3">
          <label className="block uppercase text-app-text-secondary text-xs font-semibold mb-2">
            Mandatory Requirements
          </label>{" "}
          <ReactQuill
            label="Mandatory Requirements"
            name="key3"
            value={data?.key3}
            onChange={(value) => handleInputChange({ target: { name: "key3", value } })}
            disabled={viewOnly}
          />
        </div>
        <div className="relative w-full mb-2">
          <label className="block uppercase text-app-text-secondary text-xs font-semibold mb-2">
            Optional Requirements
          </label>
          <ReactQuill
            label="Optional Requirements"
            name="key5"
            value={data?.key5}
            onChange={(value) => handleInputChange({ target: { name: "key5", value } })}
            disabled={viewOnly}
          />
        </div>

        <div className="relative w-full mb-2">
          <TextArea
            label="Notes"
            name="key6"
            value={data?.key6}
            onChange={handleInputChange}
            disabled={viewOnly}
          />
        </div>
        <div className="relative w-full mb-3">
          <UploadFile
            label="Attachments"
            imageKey="arrKey1"
            data={data}
            type="multiple"
            setData={setData}
          />
        </div>
      </div>
      {hasPermission(P.CHECKLIST.READ) && (
        <div className="p-4 absolute bottom-0 w-full border-t">
          <div className="flex justify-between gap-4">
            <Button variant="outlined" onClick={toggleDrawer}>
              Cancel
            </Button>
            <div className="flex gap-4 w-full justify-end">
              <Button variant="contained" onClick={handleAddMore} disabled={isLoading}>
                {open?.id ? "Update & Add More" : "Save & Add More"}
              </Button>
              <Button variant="contained" onClick={handleSave} disabled={isLoading}>
                {open?.id ? "Update" : "Save"}
              </Button>
            </div>
          </div>
        </div>
      )}
    </Drawer>
  );
}
